import React, { useEffect, useState } from "react";
import { Box, Typography, MenuItem, FormControl, Select } from "@mui/material";
import { SideBar } from "../../components/shared/sideBar/sideBar";
import { useAppTheme } from "../../components/themes/appThemeProvider";
import sideBarStyles from "../../components/shared/sideBar/sideBar.module.css";

export const JiraViweSideBar = ({ boards = [], onDepartmentChange }) => {
  const { mode } = useAppTheme();
  const isDarkMode = mode === "dark";

  const [departments, setDepartments] = useState([]);
  const [selectedDepartment, setSelectedDepartment] = useState("CloudOps");

  useEffect(() => {
    const uniqueDepartments = Array.from(
      new Set(boards.map((b) => b?.department).filter(Boolean))
    ).sort();

    setDepartments(uniqueDepartments);

    if (!uniqueDepartments.includes("CloudOps")) {
    } else {
    }
  }, [boards]);

  useEffect(() => {
    if (selectedDepartment && onDepartmentChange) {
      onDepartmentChange(selectedDepartment === "ALL" ? null : selectedDepartment);
    }
  }, [selectedDepartment, onDepartmentChange]);

  const availableOptions = ["ALL", ...departments];

  return (
    <SideBar>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          height: "100%",
          width: "100%",
          padding: 0,
          gap: 2,
        }}
      >
        <Box
          sx={{
            borderBottom: `1px solid ${isDarkMode ? "#333" : "#ccc"}`,
            paddingBottom: "20px",
          }}
        >
          <Typography variant="subtitle2" className={sideBarStyles.sectionTitle} sx={{ mb: 1 }}>
            Department
          </Typography>
          {departments.length > 0 && (
            <FormControl fullWidth size="small" disabled={availableOptions.length === 0}>
              <Select
                value={selectedDepartment || "ALL"} // Fallback to "ALL" if value is blank
                onChange={(e) => setSelectedDepartment(e.target.value)}
                displayEmpty
                MenuProps={{
                  PaperProps: {
                    sx: {
                      zIndex: 20000, // Make sure it's above any sidebars or grids
                    },
                  },
                }}
                sx={{
                  backgroundColor: isDarkMode ? "#333" : "#fff",
                  borderRadius: "6px",
                  fontSize: "14px",
                }}
              >
                {availableOptions.map((dept) => (
                  <MenuItem key={dept} value={dept} sx={{ zIndex: 99999999 }}>
                    {dept}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          )}
        </Box>
      </Box>
    </SideBar>
  );
};
